<template>
  <div>
    <!-- background blur when modal popup -->
    <div class="blur-bg"></div>
    <!-- Modal -->
    <div class="modal fade" id="setting-modal" tabindex="-1" aria-labelledby="settingModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h3>編輯使用者區域</h3>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>編輯區域名稱</label>
              <input class="form-control" type="text" v-model.lazy="alias" :placeholder="selected_region.name ?? '輸入區域名稱'">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" @click="editRegion()">送出</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alias: '',
    }
  },
  mounted() {
  },
  computed: {
    selected_region() {
      return this.$store.getters.selectedRegion;
    },
  },
  methods: {
    async editRegion() {
      this.closeModal();
      await axios.patch(base_url + "/api/regions/name/" + this.selected_region.id, {
        "name": this.alias
      }).then((response) => {
        this.region_name = '';
        this.$store.dispatch('setUserRegions');
      }).catch(error => this.axiosMessage(error));
      this.$store.commit('setShowSpinner', false);
    },
    closeModal() {
      const modal = this.$el.querySelector('#setting-modal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'none';
      modal.classList.remove('show');
      blur_bg.style.display = 'none';
    },
  },
}
</script>

<style scoped>
.blur-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: none;
}
</style>
